import { render, staticRenderFns } from "./yyzzMail.vue?vue&type=template&id=64ecf9ae&scoped=true"
import script from "./yyzzMail.vue?vue&type=script&lang=js"
export * from "./yyzzMail.vue?vue&type=script&lang=js"
import style0 from "./yyzzMail.vue?vue&type=style&index=0&id=64ecf9ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ecf9ae",
  null
  
)

export default component.exports